// initial state
import Router from "../../router";
import {applicationService} from "../../services";

const state = {
    title: 'Tuš',
    logo: undefined,
    loaded: false,
    urls: {
        login: {
            fb: undefined,
            google: undefined
        }
    },
    redirectInProgress: {
        status: false,
        text: '',
    },
    sent_email: {
        'title': 'Le še potrditev e-naslova',
        'text': 'Za zaključek postopka prosim potrdite povezavo, ki smo jo poslali na vaš e-naslov.'
    }
};

// getters
const getters = {

};

// actions
const actions = {
    fetchInitialInfo({dispatch, commit}) {
        applicationService.info().then(
            data => {
                commit('setApplicationLoaded', true);
                if (data.flow) {
                    commit('setApplicationTitle', data.application.name);
                    commit('setApplicationLogo', data.application.logo);
                }
                commit('setUrls', data.urls);
                dispatch('auth/me', {}, {root:true});
            },
            error => {
                commit('setApplicationLoaded', true);
                commit('setApplicationTitle', 'Tuš');
                commit('setApplicationLogo', null);
                dispatch('auth/me', {}, {root:true});
            }
        );
    },
    emailSentMessage({dispatch, commit}, {title, text}){
        commit('setEmailSent', {
            'title': title,
            'text': text
        });
        Router.push('/poslan-email')
    },
    redirect({dispatch, commit}, {url, internal, message}){
        if (internal){
            Router.push(url);
            return;
        }
        commit('setRedirectInProgress', {
            status: true,
            text: message
        });
        window.location.replace(url);
    }
};

// mutations
const mutations = {
    setApplicationLoaded(state, loaded) {
        state.loaded = loaded;
    },
    setApplicationTitle(state, title) {
        state.title = title;
    },
    setApplicationLogo(state, logo) {
        state.logo = logo;
    },
    setUrls(state, urls) {
        state.urls = urls;
    },
    setRedirectInProgress(state, {status, text}) {
        state.redirectInProgress.status = status;
        state.redirectInProgress.text = text;
    },
    setEmailSent(state, {title, text}) {
        state.sent_email = {
            title: title,
            text: text
        };
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}